import { render } from "./FormRecrutamentoFase02.vue?vue&type=template&id=2d8d0301"
import script from "./FormRecrutamentoFase02.vue?vue&type=script&lang=js"
export * from "./FormRecrutamentoFase02.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__